import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import { CommonResponse, isSuccess } from "@/api/response";
import { UpdateExternalPointRequest } from "@/api/external-point/request";
import * as ExternalPointAPI from "@/api/external-point";

const MODULE_NAME = "external-point/update";

/**
 * 外部ポイントカード紐付け更新APIのレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Update extends VuexModule {
  // state
  commonResponse: CommonResponse = {} as CommonResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.commonResponse);
  }

  get getMessage() {
    return this.commonResponse.message;
  }

  // MutationActions
  @MutationAction
  async update(updateRequest: UpdateExternalPointRequest) {
    const commonResponse = await ExternalPointAPI.update(updateRequest);
    return {
      commonResponse
    };
  }

  @MutationAction
  async clearResponse() {
    return {
      commonResponse: {} as CommonResponse
    };
  }
}

export default getModule(Update);
